module.exports = __webpack_public_path__ + "img/2021_NC.c9781897.png";